import React from 'react';

interface FooterProps {
  onFeedbackClick: () => void;
}

const Footer: React.FC<FooterProps> = ({ onFeedbackClick }) => {
  return (
    <div 
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        padding: '12px',
        backgroundColor: '#f5f5f5',
        borderTop: '1px solid #e5e5e5',
        zIndex: 100
      }}
    >
      <div 
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingLeft: '16px',
          paddingRight: '16px'
        }}
      >
        <p style={{ fontSize: '12px', color: '#666', margin: 0 }}>© {new Date().getFullYear()}</p>
        <p style={{ fontSize: '12px', color: '#666', margin: 0 }}>
          Created by{' '}
          <a
            href="https://www.dead-pixel.ca/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#1C1C1E', textDecoration: 'underline' }}
          >
            Dead Pixel
          </a>
        </p>
        <button
          onClick={onFeedbackClick}
          style={{ 
            fontSize: '12px', 
            color: '#666', 
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            textDecoration: 'underline',
            padding: 0
          }}
        >
          Share Feedback
        </button>
      </div>
    </div>
  );
};

export default Footer;